import Cookies from "js-cookie";

import { config } from "@/data/util/Config";

import { deSerialize, serialize } from "@/shared/utils/serialization";

import type { IOfflineStorage } from "./OfflineStorage";

export class CookieCache implements IOfflineStorage {
    constructor() {}

    public read(key: string, useSerializer?: boolean): any {
        if (useSerializer === undefined) useSerializer = true;

        const serializedValue = this.getCookie(key);

        if (serializedValue == null) return null;

        return useSerializer ? deSerialize(serializedValue as string) : serializedValue;
    }

    public write(key: string, value: any): void {
        const serializedValue = serialize(value);
        this.setCookie(key, serializedValue, config.cacheExpireDays);
    }

    public readString(key: string): string | null {
        return this.getCookie(key);
    }

    public writeString(key: string, value: string): void {
        this.setCookie(key, value, config.cacheExpireDays);
    }

    public remove(key: string): void {
        Cookies.remove(key, {
            path: "/",
            SameSite: "Lax",
            secure: true,
        });
    }

    private setCookie(key: string, value: string, exdays: number) {
        Cookies.set(key, value, {
            expires: exdays,
            path: "/",
            SameSite: "Lax",
            secure: true,
        });
    }

    private getCookie(key: string) {
        const value = Cookies.get(key);
        return value ?? null;
    }

    public static getClassName(): string {
        return "CookieCache";
    }
}
